import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout';
import { authGuard } from './guards/auth.guard';
import { unsavedNotesGuard } from './guards/unsaved-notes.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./features/auth-callback/auth-callback.component').then(
        (m) => m.AuthCallbackComponent,
      ),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/components/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'sector/:id',
        loadComponent: () =>
          import(
            './features/sector-techniques-list/components/sector-techniques-list.component'
          ).then((m) => m.TechniquesListComponent),
      },
      {
        path: 'sector/:id/technique/:techniqueId',
        canDeactivate: [unsavedNotesGuard],
        loadComponent: () =>
          import(
            './features/technique-detail/components/technique-detail/technique-detail.component'
          ).then((m) => m.TechniqueDetailComponent),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/login/components/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./features/register/components/register.component').then(
            (m) => m.RegisterComponent,
          ),
      },
      {
        path: 'settings',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/settings/components/settings.component').then(
            (m) => m.SettingsComponent,
          ),
      },
      {
        path: 'profile',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/user-profile/components/user-profile.component').then(
            (m) => m.UserProfileComponent,
          ),
      },
      {
        path: 'profile/edit',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/user-profile/components/edit-profile.component').then(
            (m) => m.EditProfileComponent,
          ),
      },
      {
        path: 'profile/change-password',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/user-profile/components/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'home',
      },
    ],
  },
];
